import React, {useState, useEffect, useRef} from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import {API_URL, CRM_HOST} from "../../../config.tsx";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import {
    AddBoxRounded,
    ContactSupportRounded,
    RemoveCircleOutline,
} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import Search from "@mui/icons-material/Search";
import {useTheme} from '@mui/material/styles';
import {useMediaQuery} from '@mui/material';
import styles from './LaximoVehicleContainer.module.scss';


const TabContainer = ({children}) => (
    <Box>
        {children}
    </Box>
);

function getSelectors(selectors, selector, count, limit) {
    count++;
    if (!selector.rows.length) {
        if (limit && count > limit) return [selectors, count];
        selectors.push(selector);
        return [selectors, count];
    }

    selector.rows.map(row => {
        if (limit && count > limit) return;
        if (!row.rows.length) {
            count++;
            selectors.push(row);
        }
        [selectors, count] = getSelectors(selectors, row, count, limit);
    })
    return [selectors, count];
}

const UnitListImage = ({setImageCode, selectedImageCode, detail, searchOems}) => {
    const highlightedOems = detail.details
        .filter(detailData => {
            const isSelected = selectedImageCode === detailData.imageCode;
            const isHighlighted = isSelected || (searchOems && searchOems.length && searchOems.includes(detailData.oem));
            return isHighlighted;
        })
        .map(detailData => detailData.oem);

    return (
        <div style={{position: 'relative', border: '1px solid #777', overflow: 'auto',}}>
            <div style={{transform: 'scale(' + detail.scaleValue + ')', transformOrigin: 'left top',}}>
                {
                    detail.detailsCoordinates
                        ? detail.detailsCoordinates.map(coordinates => {
                            if (!coordinates.oem) return null;

                            const matchesSearchOems = searchOems && searchOems.length && searchOems.includes(coordinates.oem);
                            const matchesHighlighted = highlightedOems.includes(coordinates.oem);
                            const isSelected = selectedImageCode === coordinates.code;

                            const isHighlighted = isSelected || matchesSearchOems || matchesHighlighted;

                            return (
                                <div
                                    className={styles.imageLink}
                                    style={{
                                        top: (coordinates.y1 - 4),
                                        left: (coordinates.x1 - 4),
                                        fontSize: 22,
                                        backgroundColor: (isHighlighted ? '#ff9800' : 'transparent'),
                                        color: (isHighlighted ? '#fff' : '#000'),
                                        cursor: 'pointer',
                                        border: '2px solid ' + (isHighlighted ? '#ff9800' : '#555'),
                                    }}
                                    onClick={() => setImageCode(selectedImageCode && selectedImageCode === coordinates.code ? '' : coordinates.code)}
                                    key={`${coordinates.x1}-${coordinates.y1}`}
                                >
                                    <Tooltip
                                        title={''}
                                        placement="top-end"
                                        disableTouchListener
                                        open={isHighlighted}
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    background: 'white',
                                                    color: 'rgba(0, 0, 0, 0.87)',
                                                    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
                                                    fontSize: 14,
                                                    minWidth: 500,
                                                    opacity: 1,
                                                    zIndex: 999,
                                                }
                                            }
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: (coordinates.x2 - coordinates.x1 + 12),
                                                height: (coordinates.y2 - coordinates.y1 + 12)
                                            }}
                                        >
                                            {isHighlighted ? coordinates.code : ' '}
                                        </div>
                                    </Tooltip>
                                </div>
                            );
                        })
                        : null
                }
            </div>
            <img src={detail.imageUrl} style={{width: 600,}}/>
        </div>
    );
};

const UnitImage = ({unit, vehicleCatalog, searchListDetailsByUnit}) => {
    const imageUrl = unit.imageUrl ? unit.imageUrl : unit.imageurl;
    if (!imageUrl) return null;

    let searchOems = [];

    if (unit.details) {
        unit.details.map((detail, key) => {
            if (key <= 3) searchOems.push(detail.oem);
        });
    }

    return (
        <Card className={styles.card}>
            <CardActionArea sx={{margin: 'auto', marginTop: 3, width: '95%', minHeight: 220}}
                            onClick={() => searchListDetailsByUnit(unit.unitId, vehicleCatalog, unit.ssd, searchOems)}>
                <CardMedia
                    sx={{
                        backgroundSize: 'contain'
                    }}
                    className={styles.media}
                    image={imageUrl.replace(/%size%/, 250)}
                    title={unit.name}
                />
                <Typography variant="caption" style={{textAlign: "center", marginTop: 24,}}>
                    {unit.name}
                </Typography>
            </CardActionArea>
            <CardActions>
                <Button style={{margin: 'auto',}} size="small"
                        onClick={() => searchListDetailsByUnit(unit.unitId, vehicleCatalog, unit.ssd, searchOems)}>Посмотреть
                    схему</Button>
            </CardActions>
        </Card>
    );
};

const Detail = ({detail, searchOems, onBack}) => {
    const [imageCode, setImageCode] = useState('');
    const [isHovering, setIsHovering] = useState(false);
    const listContainerRef = useRef(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    useEffect(() => {
        // Add to browser history when detail is shown
        window.history.pushState({detail: true}, '');

        // Handle browser back button
        const handlePopState = (event) => {
            if (event.state && event.state.detail) {
                onBack();
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [onBack]);

    const scrollToSelectedDetail = (detailCode) => {
        if (!listContainerRef.current) return;

        const selectedRow = listContainerRef.current.querySelector(`[data-detail-code="${detailCode}"]`);
        if (selectedRow) {
            const containerRect = listContainerRef.current.getBoundingClientRect();
            const rowRect = selectedRow.getBoundingClientRect();

            const isVisible = (
                rowRect.top >= containerRect.top &&
                rowRect.bottom <= containerRect.bottom
            );

            if (!isVisible) {
                selectedRow.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }
    };

    useEffect(() => {
        if (imageCode) {
            scrollToSelectedDetail(imageCode);
        }
    }, [imageCode]);

    return (
        <div style={{padding: 20,}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: 20}}>
                <Button
                    variant="contained"
                    // color="primary"
                    onClick={onBack}
                    style={{marginRight: 20, color: 'rgba(0, 0, 0, 0.87)', backgroundColor: '#ff9800'}}
                >
                    Назад
                </Button>
                <Typography variant="h4">{detail.name}</Typography>
            </div>
            <div className={styles.schemaContainer}>
                <Grid item xs={12} lg={8} md={8} sm={8}>
                    <UnitListImage
                        detail={detail}
                        setImageCode={setImageCode}
                        selectedImageCode={imageCode}
                        searchOems={isHovering ? [] : searchOems}
                    />
                </Grid>
                <Grid item xs={12} lg={4} md={4} sm={4}>
                    <div ref={listContainerRef} style={{maxHeight: 600, paddingLeft: 16, overflowY: 'auto',}}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={styles.searchDetailCell}>OEM</TableCell>
                                    <TableCell className={styles.searchDetailCell}>Наименование</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    detail.details.map((detailData) => {
                                        const isSelected = imageCode === detailData.imageCode;
                                        const isHighlighted = isSelected || (!isHovering && searchOems && searchOems.length && searchOems.includes(detailData.oem));

                                        return (
                                            <TableRow
                                                key={detailData.ssd}
                                                className={styles.detailRow}
                                                onMouseEnter={() => {
                                                    setIsHovering(true);
                                                    setImageCode(detailData.imageCode);
                                                }}
                                                onMouseLeave={() => {
                                                    setIsHovering(false);
                                                    setImageCode('');
                                                }}
                                                data-detail-code={detailData.imageCode}
                                                style={{
                                                    backgroundColor: isHighlighted ? 'rgba(0,0,0,0.1)' : 'transparent',
                                                    transition: 'background-color 0.2s ease'
                                                }}
                                            >
                                                <TableCell
                                                    className={styles.searchDetailCell}
                                                    style={{
                                                        textAlign: 'center',
                                                        position: 'relative',
                                                    }}
                                                >
                                                    {!isMobile && (
                                                        <div style={{display: 'flex', position: 'relative',}}>
                                                            <a target="_blank"
                                                               href={`/search?query=${detailData.oem}`}>{detailData.oem}</a>
                                                        </div>
                                                    )}
                                                    {isMobile && (
                                                        <Button
                                                            target="_blank"
                                                            href={`/search?query=${detailData.oem}`}
                                                            style={{fontSize: 10,}}
                                                        >
                                                            {detailData.name.toLowerCase()}
                                                        </Button>
                                                    )}
                                                </TableCell>
                                                <TableCell
                                                    className={styles.searchDetailCell}
                                                    style={{
                                                        position: 'relative',
                                                    }}
                                                >
                                                    <a target="_blank"
                                                       href={`/search?query=${detailData.oem}`}>{detailData.name.toLowerCase()}</a>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                            </TableBody>
                        </Table>
                    </div>
                </Grid>
            </div>
        </div>
    )
}

const SelectorCard = ({selector, vehicleSSD, selectGroup, perChunk}) => {
    const [limit, setLimit] = useState(8);
    let selectors = getSelectors([], selector, 0, limit)[0];
    const checkArray = [];

    return <Grid item xs={12 / perChunk} className={styles.selectorCard}>
        <div className={styles.selectorCardPaper}>
            <Typography sx={{fontSize: 16, fontWeight: 'bold'}}>{selector.label}</Typography>
            {
                selectors.map(selector => {
                    if (checkArray.includes(selector.quickGroupId)) return null;
                    checkArray.push(selector.quickGroupId);

                    return <div
                        className={styles.selectorPaperContentLink}
                        onClick={() => selectGroup(vehicleSSD, selector.quickGroupId, selector.label)}
                        key={selector.quickGroupId}
                    >
                        {selector.label}
                    </div>;
                })
            }
            {limit === 4 ? <Typography sx={{fontSize: 16, fontWeight: 'bold', cursor: "pointer"}}
                                       onClick={() => setLimit(1000)}>Ещё</Typography> : null}
            {limit > 4 ? <Typography sx={{fontSize: 16, fontWeight: 'bold', cursor: "pointer"}}
                                     onClick={() => setLimit(4)}>Скрыть</Typography> : null}
        </div>
    </Grid>
}

const CategoriesTab = ({
                           detail,
                           reload,
                           loading,
                           categories,
                           vehicle,
                           selectGroup,
                           searchListDetailsByUnit,
                           searchOems,
                           onBack
                       }) => {
    const [currentDetail, setCurrentDetail] = useState(null);

    if (detail) return <Detail
        detail={detail}
        searchOems={searchOems}
        onBack={onBack}
    />;
    if (reload || loading) return null;
    if (categories.length) return <CategoriesCard
        categories={categories}
        searchListDetailsByUnit={searchListDetailsByUnit}
        vehicle={vehicle}
        selectGroup={selectGroup}
    />;

    return <Categories
        selectors={vehicle.selectors}
        selectGroup={selectGroup}
        vehicleSSD={vehicle.ssd}
    />;
}

const CategoriesCard = ({categories, searchListDetailsByUnit, vehicle, selectGroup}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [icons, setIcons] = useState([]);

    const getIcons = () => {
        fetch(`${CRM_HOST}/laximo/group_icons`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(icons => setIcons(icons))
    };

    // useEffect(() => getIcons(), []);

    if (!categories.length) return <Grid container>
        {
            icons.map(icon => {
                return <Grid item xs={12} style={{padding: 3,}} key={icon.quickGroupId}>
                    {isMobile && (
                        <Card>
                            <CardActionArea sx={{margin: 'auto'}}
                                            onClick={() => selectGroup(vehicle.ssd, icon.quickGroupId, icon.label)}>
                                <CardMedia
                                    sx={{
                                        backgroundSize: 'contain'
                                    }}
                                    className={styles.mediaIcon}
                                    image={icon.url.replace(/%size%/, 250)}
                                    title={icon.label}
                                />
                                <Typography variant="caption"
                                            style={{textAlign: "center", marginTop: 24, paddingBottom: 8,}}>
                                    {icon.label}
                                </Typography>
                            </CardActionArea>
                        </Card>
                    )}
                </Grid>
            })
        }
        {
            icons.map(icon => {
                return <Grid item xs={2} style={{padding: 3,}} key={icon.quickGroupId}>
                    {!isMobile && (
                        <Card style={{minHeight: 200,}}>
                            <CardActionArea sx={{margin: 'auto'}}
                                            onClick={() => selectGroup(vehicle.ssd, icon.quickGroupId, icon.label)}>
                                <CardMedia
                                    className={styles.mediaIcon}
                                    sx={{
                                        backgroundSize: 'contain'
                                    }}
                                    image={icon.url.replace(/%size%/, 250)}
                                    title={icon.label}
                                />
                                <Typography variant="caption"
                                            style={{textAlign: "center", marginTop: 24, paddingBottom: 8,}}>
                                    {icon.label}
                                </Typography>
                            </CardActionArea>
                        </Card>
                    )}
                </Grid>
            })
        }
    </Grid>

    return categories.map(category => (
        <Category
            key={category.categoryId}
            category={category}
            searchListDetailsByUnit={searchListDetailsByUnit}
            vehicleBrand={vehicle.brand}
            vehicleSSD={vehicle.ssd}
            vehicleCatalog={vehicle.catalog}
        />
    ))
}

const Categories = ({selectors, selectGroup, vehicleSSD}) => {
    const windowWidth = useRef(window.innerWidth);
    useEffect(() => {
    }, [selectors]);

    const checkArray = [];
    const perChunk = windowWidth.current <= 480 ? 1 : 3;
    const result = selectors.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);
        if (!resultArray[chunkIndex]) resultArray[chunkIndex] = [];
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, [])

    return <div className={styles.cardsLines}>
        {
            result.map((selectorsParent, k) => {
                return <Grid container key={'parent-' + k}>
                    {
                        selectorsParent.map(selector => {
                            if (checkArray.includes(selector.quickGroupId)) return null;
                            checkArray.push(selector.quickGroupId);
                            return <SelectorCard key={selector.quickGroupId} selectGroup={selectGroup}
                                                 vehicleSSD={vehicleSSD} selector={selector} perChunk={perChunk}/>
                        })
                    }</Grid>
            })
        }
    </div>
}

const Catalogs = ({categories, searchListDetailsByUnit, vehicle, selectGroup}) => {
    return (
        <Grid container>
            {
                categories.map(unit => (
                    <Grid item xs={12} md={4} key={'unit-' + unit.unitId}>
                        <UnitImage unit={unit} vehicleCatalog={vehicle.catalog}
                                   searchListDetailsByUnit={searchListDetailsByUnit}/>
                    </Grid>
                ))
            }
        </Grid>
    )
}
const Vehicle = ({
                     loading,
                     vehicle,
                     schema,
                     categorySchema,
                     searchSchema,
                     searchCategoryInfo,
                     setExecuteScroll,
                     executeScroll,
                 }) => {
    const theme = useTheme();
    // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [searchString, setSearchString] = useState('');
    const [detail, setDetail] = useState(null);
    const [reload, setReload] = useState(false);
    const [categories, setCategories] = useState(schema.categories);
    const [label, setLabel] = useState('');
    const [categoryLabel, setCategoryLabel] = useState('');
    const [tabNumber, setTabNumber] = useState(0);
    const [searchOems, setSearchOems] = useState([]);

    const handleBack = () => {
        setDetail(null);
        setSearchOems([]);
        setCategories(schema.categories);
    };

    useEffect(() => {
        if (detail) {
            // Add to browser history when detail is shown
            window.history.pushState({detail: true}, '');
        }
    }, [detail]);

    useEffect(() => {
        // Handle browser back button
        const handlePopState = (event) => {
            if (event.state && event.state.detail) {
                handleBack();
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    const selectGroup = (ssd, quickGroupId, label) => {
        setDetail(null);
        setLabel(label);
        searchSchema(ssd, quickGroupId, label);
    };

    const selectCategory = (ssd, categoryId, name) => {
        setDetail(null);
        setCategoryLabel(name);
        searchCategoryInfo(ssd, categoryId, name);
    };

    const searchListDetailsByUnit = (unitId, catalog, ssd, searchOems) => {
        if (!ssd && !unitId && !catalog) return;
        setCategories([]);
        setSearchOems([]);
        setReload(true);
        fetch(`${API_URL}/list_details_by_unit?unitId=${unitId}&catalog=${catalog}&ssd=${ssd}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(detail => {
                if (Object.keys(detail).length) {
                    setDetail(detail);
                    setSearchOems(searchOems);
                } else window.alert('Информация по выбранному узлу отсутствует');
            })
            .then(() => setReload(false))
    };

    const handleChangeTab = (event, value) => {
        setTabNumber(value);
        setDetail(null);
    };

    const divRef = useRef();

    const scrollTo = () => {
        divRef.current.scrollIntoView({block: "start"});
    }

    useEffect(() => setCategories(schema.categories), [schema]);
    useEffect(() => {
        if (executeScroll) {
            scrollTo();
            setExecuteScroll(false);
        }
    }, [executeScroll]);

    if (!Object.keys(vehicle).length) return <div><Typography variant="display2">По вашему запросу ничего не
        найдено</Typography></div>;

    return (
        <Grid className={styles.root}>
            <Grid item lg={3} md={3} sm={3} xs={12}>
                <Tabs value={tabNumber} onChange={handleChangeTab}>
                    <Tab label="Категории"/>
                    <Tab label="Схемы узлов"/>
                </Tabs>
                {
                    tabNumber === 0 &&
                    <TabContainer>
                        <div>
                            <TextField
                                margin="normal"
                                fullWidth
                                placeholder="Поиск"
                                label="Поиск"
                                value={searchString}
                                variant="outlined"
                                onChange={event => setSearchString(event.target.value)}
                            />
                        </div>
                        <div className={styles.selectorCardPaper}>
                            {
                                vehicle.selectors.map((selector, k) => (
                                    <Selector
                                        key={'selector-' + k}
                                        selector={selector}
                                        selectGroup={selectGroup}
                                        vehicleSSD={vehicle.ssd}
                                        searchString={searchString}
                                    />
                                ))
                            }
                        </div>
                    </TabContainer>
                }
                {
                    tabNumber === 1 &&
                    <TabContainer>
                        {
                            vehicle.categories.map(category => (
                                <div key={category.categoryId} className={styles.selectorPaperContentLink}
                                     onClick={() => selectCategory(category.ssd, category.categoryId, category.name)}>
                                    {category.name}
                                </div>
                            ))
                        }
                    </TabContainer>
                }
            </Grid>
            <Grid item lg={9} md={9} sm={9} xs={12}>
                {
                    tabNumber === 0 &&
                    <TabContainer>
                        <div className={styles.categoriesTab}>
                            {label ? <Typography variant="h4">{label}</Typography> : null}
                            {reload || loading ?
                                <div style={{width: '100%', textAlign: 'center', marginBottom: 40,}}><CircularProgress
                                    size={60}/></div> : null}
                            <div ref={divRef} style={{position: "absolute", top: -80}}/>
                            <CategoriesTab
                                detail={detail}
                                reload={reload}
                                loading={loading}
                                vehicle={vehicle}
                                selectGroup={selectGroup}
                                categories={categories}
                                searchOems={searchOems}
                                searchListDetailsByUnit={searchListDetailsByUnit}
                                onBack={handleBack}
                            />
                        </div>
                    </TabContainer>
                }
                {
                    tabNumber === 1 &&
                    <TabContainer>
                        <Grid container style={{padding: 15,}}>
                            {categoryLabel ?
                                <Grid item xs={12}><Typography variant="h4">{categoryLabel}</Typography></Grid> : null}
                            {reload || loading ?
                                <div style={{width: '100%', textAlign: 'center', marginBottom: 40,}}><CircularProgress
                                    size={60}/></div> : null}
                            {
                                detail
                                    ? <Detail detail={detail}/>
                                    : (
                                        reload || loading
                                            ? null
                                            : <Catalogs
                                                categories={categorySchema}
                                                searchListDetailsByUnit={searchListDetailsByUnit}
                                                vehicle={vehicle}
                                                selectGroup={selectGroup}
                                            />
                                    )
                            }
                        </Grid>
                    </TabContainer>
                }
            </Grid>
        </Grid>
    );
};

function getVisibleSelector(searchString, selector) {
    if (!searchString) return true;

    const regexp = searchString ? new RegExp(searchString, "gi") : null;
    if (regexp.test(selector.label)) return true;
    if (regexp.test(selector.synonyms)) return true;

    let isVisible = false;
    selector.rows.map(row => {
        if (getVisibleSelector(searchString, row)) isVisible = true;
    });

    return isVisible;
}

const Selector = ({selector, selectGroup, vehicleSSD, searchString,}) => {
    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        setExpanded(searchString.length > 0);
    }, [selector, searchString]);

    const isVisible = getVisibleSelector(searchString, selector);
    if (!isVisible) return null;

    if (selector.rows.length === 0) {
        return selector.link === 'true'
            ? (
                <div className={styles.selectorPaperContentLink}
                     onClick={() => selectGroup(vehicleSSD, selector.quickGroupId, selector.label)}>
                    {selector.label}
                </div>
            )
            : (
                <div className={styles.selectorPaperContent}>
                    {selector.label}
                </div>
            );
    }

    return (
        <Accordion
            sx={{
                boxShadow: 'none',
                backgroundColor: '#eee',
                '&:before': {
                    background: 'none',
                },
            }}
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
        >
            <AccordionSummary
                expandIcon={expanded ? <RemoveCircleOutline/> : <AddBoxRounded/>}
                sx={{
                    padding: 0,
                }}
            >
                <Typography variant="h6" sx={{fontSize: 16}}>
                    {selector.label}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{display: 'block', padding: '0 0 0 4px'}}>
                {selector.rows.map((row, k) => (
                    <Selector key={'child-selector-' + selectGroup + '-' + k} selector={row} selectGroup={selectGroup}
                              vehicleSSD={vehicleSSD} searchString={searchString}/>))}
            </AccordionDetails>
        </Accordion>
    );
};

const Category = ({category, vehicleCatalog, searchListDetailsByUnit}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [state, setState] = useState({
        showAll: false,
        selectedDetail: null
    });

    const handleBack = () => {
        setState(prev => ({
            ...prev,
            selectedDetail: null
        }));
    };

    useEffect(() => {
        if (state.selectedDetail) {
            // Add to browser history when detail is shown
            window.history.pushState({detail: true}, '');
        }
    }, [state.selectedDetail]);

    useEffect(() => {
        // Handle browser back button
        const handlePopState = (event) => {
            if (event.state && event.state.detail) {
                handleBack();
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    if (state.selectedDetail) {
        return (
            <div>
                <div style={{display: 'flex', alignItems: 'center', marginBottom: 20}}>
                    <Button
                        variant="contained"
                        // color="primary"
                        onClick={handleBack}
                        style={{marginRight: 20, color: 'rgba(0, 0, 0, 0.87)', backgroundColor: '#ff9800'}}
                    >
                        Назад
                    </Button>
                    <Typography variant="h4">{state.selectedDetail.name}</Typography>
                </div>
                <Detail
                    detail={state.selectedDetail}
                    searchOems={[]}
                    onBack={handleBack}
                />
            </div>
        );
    }

    return (
        <div>
            {
                category.units.map(unit => (
                    <Grid container key={unit.unitId}>
                        <Grid item xs={12} md={4}>
                            <UnitImage key={'unit-' + unit.unitId} unit={unit} vehicleCatalog={vehicleCatalog}
                                       searchListDetailsByUnit={(unitId, catalog, ssd, searchOems) => {
                                           // Add to browser history before showing detail
                                           window.history.pushState({detail: true}, '');
                                           searchListDetailsByUnit(unitId, catalog, ssd, searchOems);
                                       }}/>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={styles.headCell}>OEM</TableCell>
                                        <TableCell className={styles.headCell}>Наименование</TableCell>
                                        {!isMobile && <TableCell className={styles.headCell}>Действия</TableCell>}
                                        {isMobile && <TableCell className={styles.headCell}></TableCell>}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        unit.details.map((detail, key) => {
                                            if (!state.showAll && key > 3) return null;

                                            return (
                                                <TableRow
                                                    key={detail.ssd}
                                                    className={styles.detailRow}
                                                    // onClick={() => {
                                                    //   window.history.pushState({ detail: true }, '');
                                                    //   setState(prev => ({
                                                    //     ...prev,
                                                    //     selectedDetail: {
                                                    //       ...unit,
                                                    //       details: [detail],
                                                    //       name: detail.name
                                                    //     }
                                                    //   }));
                                                    // }}
                                                >
                                                    <TableCell className={styles.searchCell}
                                                               style={{textAlign: 'center',}}>
                                                        <div style={{display: "flex",}}>
                                                            <a target="_blank"
                                                               href={`/search?query=${detail.oem}`}>{detail.oem}</a>
                                                            {!isMobile && (
                                                                <Tooltip
                                                                    placement="top-end"
                                                                    componentsProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                background: 'white',
                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
                                                                                fontSize: 14,
                                                                                minWidth: 500,
                                                                                opacity: 1,
                                                                            }
                                                                        }
                                                                    }}
                                                                    title={
                                                                        <div style={{width: 300}}>
                                                                            <div><strong>OEM: </strong>{detail.oem}
                                                                            </div>
                                                                            <div>
                                                                                <strong>Наименование: </strong>{detail.name}
                                                                            </div>
                                                                            <div>
                                                                                <strong>Количество: </strong>{detail.amount}
                                                                            </div>
                                                                            {detail.applicableModels ?
                                                                                <div><strong>Применяется в
                                                                                    моделях: </strong>{detail.applicableModels}
                                                                                </div> : null}
                                                                        </div>
                                                                    }
                                                                >
                                                                    <IconButton sx={{
                                                                        marginLeft: 12,
                                                                        padding: 0
                                                                    }}><ContactSupportRounded/></IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={styles.searchCell}>
                                                        <a target="_blank"
                                                           href={`/search?query=${detail.oem}`}>{detail.name}</a>
                                                    </TableCell>
                                                    {!isMobile && (
                                                        <TableCell className={styles.searchCell} style={{
                                                            textAlign: 'center',
                                                            position: 'relative',
                                                            minWidth: 100,
                                                        }}>
                                                            <Button
                                                                target="_blank"
                                                                href={`/search?query=${detail.oem}`}
                                                                style={{fontSize: 12}}
                                                            >
                                                                узнать цены
                                                            </Button>
                                                        </TableCell>
                                                    )}
                                                    {isMobile && (
                                                        <TableCell className={styles.searchCell}
                                                                   style={{textAlign: 'center',}}>
                                                            <Button
                                                                color="primary"
                                                                target="_blank"
                                                                href={`/search?query=${detail.oem}`}
                                                            >
                                                                <Search/>
                                                            </Button>
                                                        </TableCell>
                                                    )}
                                                </TableRow>
                                            );
                                        })
                                    }
                                    {
                                        unit.details.length > 4
                                            ? (
                                                !state.showAll
                                                    ? <TableRow>
                                                        <TableCell colSpan={3}>
                                                            <Button style={{width: '100%'}} onClick={() => setState(prev => ({
                                                                ...prev,
                                                                showAll: true
                                                            }))}><KeyboardArrowDown style={{marginRight: 20}}/> Показать
                                                                все</Button></TableCell></TableRow>
                                                    : <TableRow><TableCell colSpan={3}><Button style={{width: '100%'}}
                                                                                               onClick={() => setState(prev => ({
                                                                                                   ...prev,
                                                                                                   showAll: false
                                                                                               }))}><KeyboardArrowUp
                                                        style={{marginRight: 20}}/> Скрыть</Button>
                                                    </TableCell>
                                                    </TableRow>
                                            )
                                            : ''
                                    }
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>
                ))
            }
        </div>
    );
};

const LaximoVehicleContainer = ({vehicle}) => {
    const [schema, setSchema] = useState({categories: []});
    const [categorySchema, setCategorySchema] = useState([]);
    const [executeScroll, setExecuteScroll] = useState(false);
    const [loading, setLoading] = useState(false);

    const searchSchema = (ssd, quickGroupId, label) => {
        setLoading(true);
        fetch(`${API_URL}/catalog_schema?catalog=${vehicle.catalog}&vehicleId=${vehicle.vehicleId}&ssd=${ssd}&groupId=${quickGroupId}&label=${label}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(schema => {
                setSchema(schema);
                setLoading(false);
                setExecuteScroll(true);
                if (!schema.categories.length) window.alert('Информация по выбранному узлу отсутствует');
            })
    };

    const searchCategoryInfo = (ssd, categoryId, label) => {
        setLoading(true);
        fetch(`${API_URL}/category_unit?catalog=${vehicle.catalog}&vehicleId=${vehicle.vehicleId}&ssd=${ssd}&categoryId=${categoryId}&label=${label}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(schema => {
                setCategorySchema(schema);
                setLoading(false);
                if (!schema) window.alert('Информация по выбранному узлу отсутствует');
            })
    };

    const clearSchema = () => {
        setSchema({categories: []});
    };

    useEffect(() => {

    }, [vehicle]);
    return <Box style={{marginBottom: 15}}>
        {
            Object.keys(vehicle).length
                ? <Box>
                    <Box><span>
            <Typography
                variant="h6"
                sx={{padding: 2}}
            >
              {vehicle.brand} / {vehicle.model}
            </Typography>
            <Vehicle
                loading={loading}
                vehicle={vehicle}
                schema={schema}
                categorySchema={categorySchema}
                searchSchema={searchSchema}
                searchCategoryInfo={searchCategoryInfo}
                clearSchema={clearSchema}
                executeScroll={executeScroll}
                setExecuteScroll={setExecuteScroll}
            />
          </span></Box>
                </Box>
                : null
        }
    </Box>;
}


export default LaximoVehicleContainer;
